<template>
  <div class="booking-dialog-container">


    <el-dialog v-model="dialogVisible" :show-close="false" :modal="true" modal-class="custom-dialog-modal"
      class="custom-dialog" center @close="hide" :width="dialogWidth">
      <div class="custom-dialog-content">
        <img class="bg-dialog" src="@/assets/bg_dialog_qrcode.png" />

        <div class="qrcode-dialog-body">
          <h2 class="dialog-title">联系客服</h2>
          <div class="img-aqua-box">
            <img class="img-aqua" src="@/assets/img_aqua.png" alt="" />
          </div>
          <img class="qrcode" :src="OSSImgUrl(publicSettingData.qrcode)" />
          <p class="qrcode-dialog-desc">扫描二维码添加企业微信或拨打客服电话</p>

          <p :class="['phone-number', { mobile: isMobile() }]" @click="handlePhoneClick"><img class="phone-icon" src="@/assets/icon_phone.png" /> {{ publicSettingData.phone }}
          </p>
        </div>

        <img class="icon-close" src="@/assets/icon_close.png" @click="hide"/>
      </div>
    </el-dialog>


  </div>
</template>

<script setup>
// 价格页面逻辑
import { ref, watch, computed, onMounted, nextTick, onUnmounted } from 'vue'
import { createOrder, createPay, getSaleOrder, } from '@/api/product'
import QRCode from 'qrcode';
import { User, Lock, SuccessFilled } from '@element-plus/icons-vue'
import bgDialog from '@/assets/bg-dialog.png'
import bgTipDialog from '@/assets/bg_tip_dialog.png'
import { getCustomerManageList } from '@/api/product'
import { OSSImgUrl } from '../utils/index.Js';
import { isMobile } from '@/utils/index';

// 定义组件接收的 props
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  type: {
    type: Object,
    default: 'fee'
  }
})

const dialogVisible = ref(false)
const publicSettingData = ref({})

// 响应式弹窗宽度
const dialogWidth = computed(() => {
  console.log('dialogWidth...', window.innerWidth);
  return window.innerWidth <= 768 ? '80vw' : '468px'
})

// 监听 props.modelValue 的变化
watch(() => props.visible, (newVal) => {
  dialogVisible.value = newVal
  if (newVal) {
    getCustomerManageListApi()
  }

}, { immediate: true })

// 定义触发的事件
const emit = defineEmits(['update:visible'])


const getCustomerManageListApi = () => {
  getCustomerManageList().then((res) => {
    if (res?.data) {
      res.data.map((item) => {
        if (typeof item.setting === 'string') {
          try {
            item.setting = JSON.parse(item.setting || '{}');
          } catch {
            item.setting = {};
          }
        }
        if (item.type == 1) {
          publicSettingData.value = item.setting;
          console.log('getCustomerList...', publicSettingData.value);
        }


        return item;
      });

    }
  });
}

onMounted(() => {

})

// 在 hide 方法中也要停止轮询
const hide = () => {
  dialogVisible.value = false;
  emit('cancel')
}

// 处理电话号码点击事件
const handlePhoneClick = () => {
  if (isMobile() && publicSettingData.value.phone) {
    window.location.href = `tel:${publicSettingData.value.phone}`
  }
}

const confirm = () => {
  dialogVisible.value = false;
  emit('confirm')
}

</script>

<style scoped>
.booking-dialog-container {
  /* max-width: 1200px; */
  /* margin: 100px auto 60px; */
  padding: 0 15px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.icon-close {
  width: 28px;
  height: 28px;
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
  z-index: 999;
}


/* 自定义弹窗样式 */
.custom-dialog {
  border-radius: 16px;
  overflow: hidden;
  padding: 0;
  background: transparent;
  /* 去除弹窗背景 */
}

.custom-dialog-modal {
  backdrop-filter: blur(5px);
}

:deep(.custom-dialog .el-dialog__header) {
  display: none;
}

:deep(.custom-dialog .el-dialog__body) {
  background: transparent;
  /* 去除对话框背景 */
  padding: 0;
}

:deep(.custom-dialog .el-dialog--center) {
  padding: 0;
  background: transparent;
  /* 去除对话框背景 */
}

:deep(.el-dialog--center) {
  padding: 0;
  background: transparent;
  /* 去除对话框背景 */
}

:deep(.custom-dialog .el-dialog) {
  background: transparent;
  /* 去除对话框背景 */
}

.custom-dialog-content {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 16px;

  position: relative;
  overflow: hidden;
  background: transparent;
  /* 去除内容背景 */
  /* width: 100%; */
  /* height: 100%; */
}

.bg-dialog {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  /* height: 100%; */
}



.qrcode-dialog-body {
  position: relative;
  z-index: 2;
  /* padding: 60px 40px; */
  text-align: center;
  /* backdrop-filter: blur(2px); */
  /* background-color: rgba(255, 255, 255, 0.8); */
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* margin-top: 164px; */
  height: 432px;

  .dialog-title {
    font-weight: 600;
    font-size: 24px;
    color: #333333;
  }


  .img-aqua-box {
    display: flex;
    justify-content: center;

    .img-aqua {
      width: 101px;
      height: 9px;
    }
  }

  .qrcode {
    margin-top: 16px;
    width: 220px;
    height: 220px;
    border-radius: 12px;
  }

  .qrcode-dialog-desc {
    font-weight: 400;
    font-size: 16px;
    color: #666666;
    margin-top: 16px;
  }

  .phone-number {
    font-weight: 600;
    font-size: 28px;
    color: #FFFFFF;
    margin-top: 16px;
    display: flex;
    align-items: center;

    &.mobile {
      cursor: pointer;
    }
  }

  .phone-icon {
    width: 28px;
    height: 28px;
    margin-right: 6px;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {

  .bg-dialog {
    min-height: 322px;
  }

  .custom-dialog-content {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 16px;
    min-height: 320px;
    position: relative;
    overflow: hidden;
    background: transparent;
  }

  .qrcode-dialog-body {
    margin-top: 25px;
    height: auto;

    .dialog-title {
      font-size: 18px;
    }

    .img-aqua-box {
      display: flex;
      justify-content: center;

      .img-aqua {
        width: 65px;
        height: 5.9px;
      }
    }

    .qrcode {
      margin-top: 16px;
      width: 150px;
      height: 150px;
    }

    .dialog-desc {
      font-size: 13px;
      margin-top: 6px;
      margin-bottom: 0;
    }

    .qrcode-dialog-desc {
      font-weight: 400;
      font-size: 13px;
      color: #666666;
      margin-top: 16px;
    }


    .phone-number {
      font-weight: 600;
      font-size: 18px;
      color: #FFFFFF;
      margin-top: 11px;
      display: flex;
      align-items: center;
    }

    .phone-icon {
      width: 22px;
      height: 22px;
      margin-right: 6px;
    }

  }

  :deep(.el-dialog) {
    margin: 20vh auto !important;
    margin-left: 10vw !important;
    margin-right: 10vw !important;
  }
}
</style>